import type { ImageProps } from 'vant'
import VantImage from 'vant/lib/image'
import VantLoading from 'vant/lib/loading'
import 'vant/lib/image/index.css'
import 'vant/lib/loading/index.css'
import { getImageUrl } from '@/utils'

export default function Image(props: Partial<ImageProps> & { onClick?: (event: MouseEvent) => void, class?: any }, { slots }: { slots: any }) {
  const imgSrc = props.src ? getImageUrl(props.src) : ''

  return (
    <VantImage
      {...props}
      src={imgSrc}
      v-slots={{
        loading: () => slots.loading?.() || <VantLoading type="spinner" size="20" />,
        error:   () => slots.error?.() || null
      }}/>
  )
}
